// @flow

import React, {Component} from 'react'
import {Cell, Pie, PieChart, Sector, ResponsiveContainer} from 'recharts'
import {map} from 'ramda'

import {RiskRating} from '@/types'

type Props = {
  data: Array<{name: string, value: number, colour: string}>,
  segmentClick?: (any) => void,
  riskLevel: RiskRating,
}

const riskLevels = ['A', 'B', 'C', 'D', 'E']

const renderActiveShape = (props: any) => {
  const RADIAN = Math.PI / 180
  const {
    cx, cy, midAngle, innerRadius, outerRadius,
    startAngle, endAngle, fill, payload, percent,
  } = props
  const sin = Math.sin(-RADIAN * midAngle)
  const cos = Math.cos(-RADIAN * midAngle)
  const sx = cx + (outerRadius + 10) * cos
  const sy = cy + (outerRadius + 10) * sin
  const mx = cx + (outerRadius + 20) * cos
  const my = cy + (outerRadius + 20) * sin
  const ex = mx + (cos >= 0 ? 1 : -1) * 10
  const ey = my
  const textAnchor = cos >= 0 ? 'start' : 'end'

  const renderedLabel = renderLabelName(payload.name, cx)
  const textYPos = cy - (renderedLabel.length * 8)

  return (
    <g>
      <text x={cx} y={textYPos} dy={8} textAnchor="middle">
        {renderedLabel}
        <tspan x={cx} dy='1em'>{`(${(percent * 100).toFixed(2)}%)`}</tspan>
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 5}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
      <text x={ex + (cos >= 0 ? 1 : -1) * 10} y={ey} textAnchor={textAnchor} fill="#333">
        {renderLabelName(payload.name, ex + (cos >= 0 ? 1 : -1) * 10)}
      </text>
      {/* <text x={ex + (cos >= 0 ? 1 : -1) * 10} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`(${(percent * 100).toFixed(2)}%)`}
      </text> */}
    </g>
  )
}

const renderLabelName = (label, x) => {
  const splittedLabel = label.split(' ')
  return splittedLabel.map((label, index) => <tspan key={index} dy={index > 0 ? '1em' : ''} x={x}>{label}</tspan>)
}

const renderCell = ({name, colour}: Object) =>
  <Cell key={name} fill={colour} />

export class RawDonutChart extends Component<Props, *> {
  constructor (props: Props) {
    super(props)

    this.state = {
      activeIndex: 0,
    }
  }

  onPieEnter = (data: any, index: number) => {
    this.setState({
      activeIndex: index,
    })
  }

  render = () =>
    <ResponsiveContainer height={250} width="200%">
      <PieChart margin={{top: 50, right: 0, left: -118, bottom: 50}}>
        <Pie
          data={this.props.data}
          nameKey="name"
          dataKey="value"
          activeIndex={this.state.activeIndex}
          activeShape={renderActiveShape}
          onMouseEnter={this.onPieEnter}
          onClick={this.props.segmentClick}
          innerRadius={45}
          outerRadius={70}
          isAnimationActive={false}
        >
          {map(renderCell, this.props.data)}
        </Pie>
      </PieChart>
    </ResponsiveContainer>

  componentWillReceiveProps = (nextProps: Props) => {
    const nextIndex = riskLevels.indexOf(nextProps.riskLevel)
    if (nextIndex > -1 && nextIndex !== this.state.activeIndex) {
      this.setState({
        activeIndex: nextIndex,
      })
    }
  }
}

export default RawDonutChart



// WEBPACK FOOTER //
// ./src/elements/donut-chart.js